module.exports = __webpack_public_path__ + "img/guardian_teaspill.9597798d.png";